import { MAT_SNACK_BAR_DATA, MatSnackBarRef } from '@angular/material';
import { Inject, Component } from '@angular/core';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { MatIcon } from '@angular/material/icon';
import { MatSuffix } from '@angular/material/select';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    selector: 'app-remote-confirmation',
    templateUrl: './remote-confirmation.component.html',
    styleUrls: ['./remote-confirmation.component.scss'],
    imports: [MatIcon, MatSuffix, TranslatePipe]
})
export class RemoteConfirmationComponent {
  /**
  * @var CONFIRMATION_MESSAGES to store the messages for each type of confirmation
  **/
  static CONFIRMATION_MESSAGES = {
    'remote-authorize': 'label.remote-authorize'
  };
  /**
  * @var message to store the message for the corresponding type
  **/
  message: string;
  /**
  * @var isSuccess to store the isSuccess for the corresponding type
  **/
  public isSuccess: string;
  constructor(
    private snackBarRef: MatSnackBarRef<RemoteConfirmationComponent>,
    public translate: TranslationService,
    @Inject(MAT_SNACK_BAR_DATA) public data: any,
  ) {
    this.isSuccess = data.success;
    this.message = !!RemoteConfirmationComponent.CONFIRMATION_MESSAGES[data.type] ?
      `remote-confirmation.${RemoteConfirmationComponent.CONFIRMATION_MESSAGES[data.type]}${this.isSuccess ? '' : '-not'}` : '';
  }

  /**
  * @method close close the confirmation dialog
  **/
  public close(): void {
    this.snackBarRef.dismissWithAction();
  }
}
